import { render } from "./InventorySummaryDialog.vue?vue&type=template&id=98ecc25a&scoped=true&ts=true"
import script from "./InventorySummaryDialog.vue?vue&type=script&lang=ts"
export * from "./InventorySummaryDialog.vue?vue&type=script&lang=ts"

import "./InventorySummaryDialog.vue?vue&type=style&index=0&id=98ecc25a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ecc25a"]])

export default __exports__